import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-726cac3a")

_pushScopeId("data-v-726cac3a")
const _hoisted_1 = { class: "flex flex-row justify-between" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "counter" }
const _hoisted_4 = { class: "counter" }
const _hoisted_5 = { class: "h-full w-full" }
const _hoisted_6 = {
  key: 1,
  class: "h-full w-full m-auto flex flex-col pt-12"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_DetailLayout, {
      title: _ctx.$t('sti.needToSti.pageTitle'),
      "vertical-separator": false,
      "full-page": "",
      onBack: 
        () => {
          _ctx.$route.query['isNow']
            ? _ctx.$router.push('/booking')
            : _ctx.$route.query['isSti']
            ? _ctx.$router.push('/station-transit-in')
            : _ctx.$router.push('/station-transit-in/update');
        }
      
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Search, {
              class: "w-64 stt-due-list-search",
              value: _ctx.parameters.search,
              placeholder: _ctx.$t('sti.needToSti.searchPlaceholder'),
              onInput: _ctx.onSearch,
              onClear: _ctx.onSearch
            }, null, 8, ["value", "placeholder", "onInput", "onClear"]),
            _createVNode(_component_SelectSearch, {
              placeholder: _ctx.$t('sti.needToSti.allPartner'),
              customWidth: "w-52",
              serverSide: false,
              options: _ctx.STIBookedListOptions,
              modelValue: _ctx.parameters.booked,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.parameters.booked = $event)),
              isDisabled: _ctx.isAccountPOS,
              onChange: _cache[2] || (_cache[2] = 
                () => {
                  _ctx.controller.setFirstPageSTTDue();
                  _ctx.fetchSttDueList();
                  _ctx.fetchNeedStiSummary();
                }
              )
            }, null, 8, ["placeholder", "options", "modelValue", "isDisabled"]),
            _createVNode("button", {
              class: ["ml-4 btn-filter", { 'filter-active': _ctx.parameters.isNow }],
              onClick: _cache[3] || (_cache[3] = 
                () => {
                  _ctx.controller.setFirstPageSTTDue();
                  _ctx.parameters.isNow = !_ctx.parameters.isNow;
                  _ctx.parameters.isOverdue = false;
                  _ctx.fetchSttDueList();
                }
              )
            }, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("sti.needToSti.filterNow")), 1),
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.controller.STISTTDueSummaryData.totalNow), 1)
            ], 2),
            _createVNode("button", {
              class: ["ml-2 btn-filter", { 'filter-active': _ctx.parameters.isOverdue }],
              onClick: _cache[4] || (_cache[4] = 
                () => {
                  _ctx.parameters.isOverdue = !_ctx.parameters.isOverdue;
                  _ctx.parameters.isNow = false;
                  _ctx.controller.setFirstPageSTTDue();
                  _ctx.fetchSttDueList();
                }
              )
            }, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("sti.needToSti.filterOverdue")), 1),
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.controller.STISTTDueSummaryData.totalOverdue), 1)
            ], 2)
          ]),
          _createVNode(_component_LpButton, {
            title: _ctx.$t('sti.needToSti.download'),
            outline: "",
            textColor: "red-lp-100",
            fontWeight: "semibold",
            disabled: !_ctx.controller.sttDueListData.data.length,
            onClick: _ctx.downloadExcel
          }, null, 8, ["title", "disabled", "onClick"])
        ]),
        _createVNode("div", _hoisted_5, [
          (_ctx.controller.sttDueListData.data.length || _ctx.controller.isLoading)
            ? (_openBlock(), _createBlock(_component_TableV2, {
                key: 0,
                columns: _ctx.columns,
                data: _ctx.controller.sttDueListData.data,
                pagination: _ctx.controller.sttDueListData.pagination,
                "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => (_ctx.controller.sttDueListData.pagination = $event)),
                isRightFreeze: "",
                isShowTryAgainBtn: "",
                errorCause: _ctx.controller.errorCause,
                onTryAgain: _ctx.fetchSttDueList,
                pinnedSubstractHeight: "300px",
                paginationStyle: "v3",
                borderTop: false,
                borderBottom: false,
                loading: _ctx.controller.isLoading,
                totalColumnFreeze: 1,
                isNoPaddingBottom: "",
                onRequest: _ctx.fetchSttDueList
              }, null, 8, ["columns", "data", "pagination", "errorCause", "onTryAgain", "loading", "onRequest"]))
            : _createCommentVNode("", true),
          (
              !_ctx.controller.isLoading && !_ctx.controller.sttDueListData.data.length
            )
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_EmptyState)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "onBack"])
  ]))
})